import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-77ad1506")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_date_pager = _resolveComponent("date-pager")
  const _component_time_table = _resolveComponent("time-table")
  const _component_vue_y_scroll_area = _resolveComponent("vue-y-scroll-area")
  const _component_vue_content = _resolveComponent("vue-content")

  return (_openBlock(), _createBlock(_component_vue_content, { class: "time-table-frame" }, {
    default: _withId(() => [
      _createVNode(_component_date_pager, {
        class: "vue-content-edit-box",
        year: _ctx.year,
        "onUpdate:year": _cache[1] || (_cache[1] = ($event: any) => (_ctx.year = $event)),
        month: _ctx.month,
        "onUpdate:month": _cache[2] || (_cache[2] = ($event: any) => (_ctx.month = $event)),
        day: _ctx.day,
        "onUpdate:day": _cache[3] || (_cache[3] = ($event: any) => (_ctx.day = $event))
      }, null, 8, ["year", "month", "day"]),
      _createVNode(_component_vue_y_scroll_area, null, {
        default: _withId(() => [
          _createVNode(_component_time_table, {
            hourRange: _ctx.hourRange,
            hourList: _ctx.hourList,
            appointmentList: _ctx.appointmentList,
            startTime: _ctx.startTime,
            "onUpdate:startTime": _cache[4] || (_cache[4] = ($event: any) => (_ctx.startTime = $event)),
            endTime: _ctx.endTime,
            "onUpdate:endTime": _cache[5] || (_cache[5] = ($event: any) => (_ctx.endTime = $event))
          }, null, 8, ["hourRange", "hourList", "appointmentList", "startTime", "endTime"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})